

import React from "react";

interface Props {
  questNo: number;
  progress: number;
  maxProgress: number;
}

// const OUTER_WIDTH = 400;
const OUTER_WIDTH = 580;
const INNER_PADDING = 10;
const INNER_WIDTH = OUTER_WIDTH - INNER_PADDING * 2; // 680

const QuestProgressBar: React.FC<Props> = ({
  questNo,
  progress,
  maxProgress,
}) => {
  const safeProgress = Math.max(0, progress);
  const safeMax = Math.max(1, maxProgress);

  const ratio = Math.min(safeProgress / safeMax, 1);
  const fillWidth = INNER_WIDTH * ratio;
  const percentage = Math.round(ratio * 100);
  return (
    <svg width="850" height="30" viewBox="70 18 850 40">
      <defs>
        <linearGradient id={`grad-${questNo}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#3CFFC6" />
          <stop offset="100%" stopColor="#00ffff" />
        </linearGradient>

        <filter id={`glow-${questNo}`} x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="8" />
        </filter>
      </defs>

      {/* <g transform="translate(75,110)"> */}
      <g transform="translate(195,14)">
        {/* Titles */}
        {/* <text x="0" y="-25" fill="white" fontSize="25" fontWeight="bold" textAnchor="start">
          GOAL SETTING
        </text> */}

        {/* <text x="450" y="-25" fill="white" fontSize="25" textAnchor="end" fontWeight="bold">
          QUEST {questNo} STATUS BAR
        </text> */}

        {/* Outer bar */}
        <rect
          x="0"
          y="8"
          width={OUTER_WIDTH}
          height="40"
          rx="20"
          fill="none"
          stroke={`url(#grad-${questNo})`}
          strokeWidth="4"
          opacity="0.8"
        />

        {/* Inner progress (CORRECT MATH) */}
        <rect
          x={INNER_PADDING}
          y={INNER_PADDING}
          width={fillWidth}
          height="20"
          rx="10"
          fill={`url(#grad-${questNo})`}
          filter={`url(#glow-${questNo})`}
        />
        {/* Percentage text outside */}
        <text
          x={OUTER_WIDTH + 30}
          y="27"
          fill="#00ffff"
         
          fontWeight="bold"
          textAnchor="start"
            style={{
    fill: "#00f2ff",              // ✅ same color as Vision Deck
    letterSpacing: "2px",         // ✅ matches style
    textTransform: "uppercase",   // ✅ matches style
     fontSize:"46"
  }}
        >
          {percentage}%
        </text>
        {/* Optional text (debug / UX) */}
        <text
          x="350"
          y="27"
          textAnchor="middle"
          fill="white"
          fontSize="14"
          opacity="0.9"
        >
          {/* {progress} / {maxProgress} */}
        </text>
      </g>
    </svg>
  );
};

export default QuestProgressBar;
